import { useLocation, useHistory } from 'react-router-dom';

const useSearchParams = () => {
  const location = useLocation();
  const history = useHistory();

  const getSearchParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const paramsToObj = {};
    for (const [key, value] of searchParams) {
      paramsToObj[key] = value;
    }

    return paramsToObj;
  };

  const setSearchParams = (params = {}) => {
    const searchParams = new URLSearchParams(location.search); // URL params as Map Object
    const arrayParams = Object.entries(params); // URL params array which is coming
    const locationSearch = Object.keys(getSearchParams()); // Array of params keys from URL

    if (arrayParams.length) {
      arrayParams.entries((key, value) => searchParams.set(key, value));
    } else if (locationSearch.length) {
      for (const key of locationSearch) {
        searchParams.delete(key);
      }
    }

    for (const key in params) {
      const value = params[key];
      searchParams.set(key, value);
    }

    history.replace(`?${searchParams.toString()}`);
  };

  return { setSearchParams, getSearchParams };
};
export default useSearchParams;
